<form [formGroup]="kind">
    @if (kinderen.length > 0) {
        <div formArrayName="kinderen">
            @for (kind of kinderen.controls; track $index; let i = $index) {
                <div [formGroupName]="i" class="row">
                    <snelstart-ui-text-form-control (change)="saveForm()"
                                                    [label]="i === 0 ? 'Voornaam' : ''"
                                                    class="custom-input-250 col-auto"
                                                    formControlName="voornaam"
                                                    id="voornaam"
                    >
                    </snelstart-ui-text-form-control>
                    <snelstart-ui-date-form-control (change)="saveForm()"
                                                    [label]="i === 0 ? 'Geboortedatum' : ''"
                                                    [required]=true
                                                    class="custom-input-200 col-auto"
                                                    formControlName="geboortedatum"
                                                    id="geboortedatum"
                                                    placeholder="dd-mm-jjjj"
                    >
                    </snelstart-ui-date-form-control>
                    <snelstart-ui-bsn-form-control (change)="saveForm()"
                                                   [label]="i === 0 ? 'Burgerservicenummer' : ''"
                                                   class="custom-input-200 col-auto"
                                                   formControlName="bsn"
                                                   id="bsn"
                    >
                    </snelstart-ui-bsn-form-control>
                    <div class="col-auto">
                        <snelstart-ui-button (click)="this.showDialog(i)"
                                             [class]="i === 0 ? 'custom-input-200 pt-3' : 'custom-input-200'"
                                             icon="plus"
                                             type="secondary">Gegevens huishouden
                        </snelstart-ui-button>
                    </div>

                    <snelstart-ui-button (click)="verwijderRijKinderen(i)"
                                         [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                         icon="trash"
                                         iconType="light"
                                         id="buttonDelete"
                                         size="medium"
                                         type="secondary"
                    >
                    </snelstart-ui-button>
                </div>
            }
        </div>
    }
</form>

<snelstart-ui-button (click)="addRijKinderen()" class="snelstart-ui-button" icon="plus" id="toevoegKind"
                     type="link">Kind toevoegen
</snelstart-ui-button>


<snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="kindBijzonderheden" size="lg"
                                title="Situatie kind & huishouden">
    <snelstart-ui-dialog-body>
        <form [formGroup]="kind">
            <div formArrayName="kinderen">
                @for (kind of kinderen.controls; track $index; let i = $index) {
                    <div [formGroupName]="i">
                        <div *ngIf="i === this.index">

                            <!-- // situatie heel jaar alleenstaand of gewijzigd + niet samen aangifte of samenwonend zonder fiscaal partner-->
                            @if ((incomeTaxEntity.aangifte?.aangever?.burgerlijkeStaat === AangeverBurgerlijkeStaat.ALLEENSTAAND) ||
                            (incomeTaxEntity.aangifte?.aangever?.burgerlijkeStaat === AangeverBurgerlijkeStaat.SITUATIE_GEWIJZIGD &&
                                !incomeTaxEntity.aangifte?.gezamenlijkeAangifte) ||
                            (incomeTaxEntity.aangifte?.aangever?.burgerlijkeStaat === AangeverBurgerlijkeStaat.SAMENWONEND &&
                                incomeTaxEntity.aangifte?.aangever?.samenwoonSituatie === AangeverSamenwoonSituatie.GEEN)) {
                                <div class="row align-items-center">
                                    <div class="col ps-1">
                                        <p>Hoorde {{ kinderen.controls[i].get('voornaam')?.value || 'het kind' }}
                                            in {{ this.incomeTaxEntity.aangifte?.aangifteJaar }} minstens 6 maanden bij
                                            het huishouden van <b>aangever</b>?</p>
                                    </div>
                                    <div class="col-auto ms-auto pe-2">
                                        <snelstart-ui-select-form-control
                                                (change)="saveForm()"
                                                [options]="itemsJaNee"
                                                class="custom-input-150"
                                                formControlName="ingeschrevenOpAdresAangever"
                                                id="ingeschrevenOpAdresAangever-{{i}}"
                                        >
                                        </snelstart-ui-select-form-control>
                                    </div>
                                </div>
                                @if (kinderen.controls[i].get('ingeschrevenOpAdresAangever')?.value === false) {
                                    <div class="row align-items-center">
                                        <div class="col ps-1 pt-1">
                                            <p>Was <b>aangever</b> in {{ this.incomeTaxEntity.aangifte?.aangifteJaar }}
                                                minstens 6 maanden co-ouder
                                                van {{ kinderen.controls[i].get('voornaam')?.value || 'het kind' }}?</p>
                                        </div>
                                        <div class="col-auto ms-auto pe-2">
                                            <snelstart-ui-select-form-control
                                                    (change)="saveForm()"
                                                    [options]="itemsJaNee"
                                                    class="custom-input-150 col-auto"
                                                    formControlName="coOuderschap"
                                                    id="coOuderschap-{{ i }}"
                                            >
                                            </snelstart-ui-select-form-control>
                                        </div>
                                    </div>
                                }
                            }

                            <!-- // situatie heel jaar gehuwd of samenwonend-->
                            @if ((incomeTaxEntity.aangifte?.aangever?.burgerlijkeStaat === AangeverBurgerlijkeStaat.GEHUWD ||
                                incomeTaxEntity.aangifte?.aangever?.burgerlijkeStaat === AangeverBurgerlijkeStaat.SAMENWONEND) &&
                            incomeTaxEntity.aangifte?.gezamenlijkeAangifte) {
                                <div class="row align-items-center">
                                    <div class="col ps-1">
                                        <p>Hoorde {{ kinderen.controls[i].get('voornaam')?.value || 'het kind' }}
                                            in {{ this.incomeTaxEntity.aangifte?.aangifteJaar }} minstens 6 maanden bij
                                            het huishouden van <b>aangever en partner</b>?</p>
                                    </div>
                                    <div class="col-auto ms-auto pe-2">
                                        <snelstart-ui-select-form-control
                                                (change)="saveForm()"
                                                [options]="itemsJaNee"
                                                class="custom-input-150"
                                                formControlName="ingeschrevenOpAdresAangever"
                                                id="ingeschrevenOpAdresAangever-{{i}}"
                                        >
                                        </snelstart-ui-select-form-control>
                                    </div>
                                </div>
                                @if (kinderen.controls[i].get('ingeschrevenOpAdresAangever')?.value === false) {
                                    <div class="row align-items-center">
                                        <div class="col ps-1 pt-1">
                                            <p>Was <b>aangever of partner</b>
                                                in {{ this.incomeTaxEntity.aangifte?.aangifteJaar }}
                                                minstens 6 maanden co-ouder
                                                van {{ kinderen.controls[i].get('voornaam')?.value || 'het kind' }}?</p>
                                        </div>
                                        <div class="col-auto ms-auto pe-2">
                                            <snelstart-ui-select-form-control
                                                    (change)="saveForm()"
                                                    [options]="itemsJaNee"
                                                    class="custom-input-150 col-auto"
                                                    formControlName="coOuderschap"
                                                    id="coOuderschap-{{ i }}"
                                            >
                                            </snelstart-ui-select-form-control>
                                        </div>
                                    </div>
                                }
                            }

                            <!-- // situatie gewijzigd & gezamenlijke aangifte-->
                            @if (incomeTaxEntity.aangifte?.aangever?.burgerlijkeStaat === AangeverBurgerlijkeStaat.SITUATIE_GEWIJZIGD &&
                            incomeTaxEntity.aangifte?.gezamenlijkeAangifte) {
                                <div class="row align-items-center">
                                    <div class="col ps-1">
                                        <p>Hoorde {{ kinderen.controls[i].get('voornaam')?.value || 'het kind' }}
                                            in {{ this.incomeTaxEntity.aangifte?.aangifteJaar }} minstens 6 maanden bij
                                            het huishouden van <b>aangever</b>? <br/>
                                            Of was <b>aangever</b>
                                            in {{ this.incomeTaxEntity.aangifte?.aangifteJaar }} minstens 6 maanden
                                            co-ouder van {{ kinderen.controls[i].get('voornaam')?.value || 'het kind' }}
                                            ?</p>
                                    </div>
                                    <div class="col-auto ms-auto pe-2">
                                        <snelstart-ui-select-form-control
                                                (change)="saveForm()"
                                                [options]="itemsJaNee"
                                                class="custom-input-150"
                                                formControlName="ingeschrevenOpAdresAangever"
                                                id="ingeschrevenOpAdresAangever-{{i}}"
                                        >
                                        </snelstart-ui-select-form-control>
                                    </div>
                                </div>
                                <div class="row align-items-center">
                                    <div class="col ps-1">
                                        <p>
                                            Hoorde {{ kinderen.controls[i].get('voornaam')?.value || 'het kind' }} {{ this.incomeTaxEntity.aangifte?.aangifteJaar }}
                                            minstens 6 maanden bij het huishouden van <b>partner</b>? <br/>Of
                                            was <b>partner</b> in {{ this.incomeTaxEntity.aangifte?.aangifteJaar }}
                                            minstens 6 maanden co-ouder
                                            van {{ kinderen.controls[i].get('voornaam')?.value || 'het kind' }}?</p>
                                    </div>
                                    <div class="col-auto ms-auto pe-2">
                                        <snelstart-ui-select-form-control
                                                (change)="saveForm()"
                                                [options]="itemsJaNee"
                                                class="custom-input-150 col-auto"
                                                formControlName="ingeschrevenOpAdresPartner"
                                                id="ingeschrevenOpAdresAangever-{{i}}"
                                        >
                                        </snelstart-ui-select-form-control>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
        </form>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons>
        <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren
        </snelstart-ui-button>
        <snelstart-ui-button btn-x icon="check" id="save" type="primary">Opslaan</snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>

